import React from "react";
import CreateShop from "../../components/Shop/CreateShop";

const CreateShopPage = () => {
  return (
    <div className=" min-h-screen bg-gray-300">
      <br />
      <CreateShop />
    </div>
  );
};

export default CreateShopPage;
